import React, { useEffect, useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import TopNav from 'components/TopNav';
import Button from '@material-ui/core/Button';
import ListItem from '@material-ui/core/ListItem';
import List from '@material-ui/core/List';
import { ACCESS_PAGE_LINK_STICKY_CONTENT_TYPE, DEFINED_TYPE_LINKS, PROFILE, SEARCH_TYPE, SEARCH_USER_TRIAL_FILTER } from '../../config/constants';
import styles from './styles.module.scss';
import { useQuery, useQueryClient } from 'react-query';
import * as searchApi from 'api/search';
import { getProfileMetaNoLogin } from 'api/resources';
import { Col, Row } from 'antd';
import FormDialog from 'components/SearchFormDialog';
import { useSelector } from 'react-redux';
import {
  getLocalStorage,
  removeLocalStorage,
  serializeFormData,
  setLocalStorage,
  textFooterEnv,
} from '../../utils/utils';
import { getTextWebPages } from 'api/textWebPage';
import { AppContext } from '../../context/AppContext';


const styleWrapInline = {
  display: 'inline-block',
};

const styleWrap = {
  fontSize: '95%',
  fontColor: 'var(--emperor)',
  fontFamily: '"Times New Roman", Times, serif, ヒラギノ角ゴ ProN',
};

const styleItems = {
  padding: '4px 10px 0 10px',
};

const styleListItem2 = {
  padding: '0 0 4px 0',
};

function SearchTrial(props) {
  const appContext = useContext(AppContext);
  const history = useHistory();
  const queryClient = useQueryClient();
  const [photoStatus, setPhotoStatus] = useState('');
  const [ageFrom, setAgeFrom] = useState('');
  const [ageTo, setAgeTo] = useState('');
  const [provinces, setProvinces] = useState([]);
  const [values, setValues] = useState({});
  const [gender, setGender] = useState(true);
  const { data: profileMetaNoLogin } = useQuery('profileMetaNoLogin', getProfileMetaNoLogin, { cacheTime: Infinity, });
  const envInfoList = useSelector((state) => state.envInfo.data);
  const listState = appContext.listState;
  const stickyContent = props?.textWebPage || '';

  const handleClearSearch = async () => {
    setPhotoStatus(null);
    setAgeFrom(null);
    setAgeTo(null);
    setProvinces([]);
    setValues({});
    await removeLocalStorage(SEARCH_USER_TRIAL_FILTER);
  };

  useEffect(() => {
    const fetchLocalStorage = async () => {
      const dataRaw = await getLocalStorage(SEARCH_USER_TRIAL_FILTER);
      if (dataRaw) {
        try {
          const data = JSON.parse(dataRaw);
          if (data?.avatar) {
            setPhotoStatus(data?.avatar);
          }
          if (data?.age_from) {
            setAgeFrom(data?.age_from);
          }
          if (data?.age_to) {
            setAgeTo(data?.age_to);
          }
          if (data?.profiles) {
            setValues(data?.profiles);
          }
          if (data?.states) {
            setProvinces(data?.states);
          }
          setGender(data?.gender);
        } catch (e) {
          // Todo
        }
      }
    };

    fetchLocalStorage();
  }, []);

  let displayAgeList = () => {
    let list = [];
    for (let i = 18; i <= 100; i++) {
      list.push(i);
    }
    return list;
  };

  const handleSearch = async () => {
    const params = {
      avatar: !photoStatus ? null : photoStatus,
      age_from: ageFrom ? ageFrom : '',
      age_to: ageTo ? ageTo : '',
      profiles: { ...values },
      states: !provinces ? null : provinces,
      gender: gender,
    };
    await setLocalStorage(SEARCH_USER_TRIAL_FILTER, JSON.stringify(params));

    let sd = {
      avatar: params.avatar,
      age_from: params.age_from,
      age_to: params.age_to,
      profiles: JSON.stringify(params.profiles),
      states: params.states && params.states.length ? JSON.stringify(params.states) : null,
      gender: params.gender,
    };

    try {
      // const { data: userSearchList, message } = await searchApi.searchUserTrial(data);

      // Set data to query data after fetch api
      // queryClient.setQueryData('userSearchList', userSearchList);
      // queryClient.setQueryData('userSearchListMessage', message);
      history.push({ pathname: `${process.env.RAZZLE_PUBLIC_URL}/search-user-trial-result`, search: `?${serializeFormData(sd)}` });
    } catch (e) {
    }
  };

  const handleOnchange = (value, key) => {
    setValues({ ...values, [key]: value });
    if (key === 'states') {
      setProvinces(value);
    }
  };

  const showValueStates = () => {
    const dataTags = values?.states ?? [];

    return listState?.filter(item => dataTags.includes(item.id))
      .map(ele => `<span class="d-symbol-search">${ele.label}</span>`)
      .join('');
  };

  const showProfile = (list, data) => {
    if (data) {
      if (Array.isArray(data)) {
        let result = '';
        data.map((item) => {
          list.forEach(profile => {
            if (profile.value === item) {
              result += `<span class="d-symbol-search">${profile.label}</span>`;
            }
          });
        });

        return result;
      } else {
        return list.find((item) => item.value === data)?.label;
      }
    }
    // return null;
  };

  const renderSearchBox = () => {
    const userGender = gender ? 'male' : 'female';
    // List Group Resource Profile
    const profileParent = {};

    const resourceChildren = profileMetaNoLogin?.data.reduce((accumulator, currentItem) => {
      if (currentItem.gender === userGender) {
        const keyProfile = currentItem['profile'];
        // handle Profile Parent
        if (currentItem.value === PROFILE.ROOT) {
          // check Profile Parent is exist in List Group Resource Profile
          if (!profileParent[keyProfile]) {
            profileParent[keyProfile] = {};
          }
          // Title of Resource Item
          profileParent[keyProfile]['title'] = currentItem.label;
          // Profile Order to specify the order displayed on the Profile Screen
          profileParent[keyProfile]['searchOrder'] = currentItem.searchOrder;
          profileParent[keyProfile]['searchType'] = currentItem.searchType;
        }
        // Handle Profile Children
        if (currentItem.value !== PROFILE.ROOT) {
          // Group By Profile Parent
          if (!accumulator[keyProfile]) {
            accumulator[keyProfile] = [];
          }
          accumulator[keyProfile].push(currentItem);
        }
      }
      return accumulator;
    }, []);

    //Display List Profile Group and sorting by profileOrder that is used in Profile screen
    return Object.keys(profileParent)
      .sort((a, b) => profileParent[a].searchOrder - profileParent[b].searchOrder)
      .map((profile, key) => {
        if (Number(profileParent[profile].searchType) === SEARCH_TYPE.DROPDOWN) {
          return (
            <div key={key}>
              <ListItem className={`${styles.lableSelect} font-2`}
                        style={{ ...styleItems }}>{profileParent[profile]?.title}</ListItem>
              <ListItem style={{ ...styleListItem2 }}>
                <div className="d-item-box-search">
                  <div className="d-text-right" style={(styleWrapInline, { width: '100%', position: 'relative' })}>
                    <FormDialog
                      namelabel={profileParent[profile]?.title}
                      namevalue={values[profile] || []}
                      resource={resourceChildren[profile]}
                      onchangeData={(e) => handleOnchange(e, profile)}
                      type={'single'}
                      text={showProfile(resourceChildren[profile], values[profile])}
                    />
                  </div>
                </div>
              </ListItem>
            </div>
          );
        }

        if (Number(profileParent[profile].searchType) === SEARCH_TYPE.CHECKBOX) {
          return (
            <Row style={{ marginTop: 3 }} key={key}>
              <Col xs={12} style={{ padding: '2px 0 0 0' }}>
                <span style={{ ...styleWrap, ...styleItems }} className={`${styles.lableSelect} font-2`}>
                  {profileParent[profile]?.title}
                </span>
              </Col>
              <Col xs={12} style={{ padding: '0 0 3px' }}>
                <div className="d-item-box-search-text">
                  <FormDialog
                    namevalue={values[profile] || []}
                    namelabel={profileParent[profile]?.title}
                    resource={resourceChildren[profile]}
                    onchangeData={(e) => handleOnchange(e, profile)}
                    type={'multiple'}
                    text={showProfile(resourceChildren[profile], values[profile])}
                  />
                </div>
              </Col>
            </Row>
          );
        }

        if (Number(profileParent[profile].searchType) === SEARCH_TYPE.RANGE) {
          return (
            <div key={key}>
              <ListItem className={`${styles.lableSelect} font-2`}
                        style={{ ...styleItems }}>{profileParent[profile]?.title}</ListItem>
              <ListItem style={{ ...styleListItem2 }}>
                <div className="d-item-box-search d-flex justify-content-center">
                  <div className="d-range-left" style={(styleWrapInline, { width: '100%', position: 'relative' })}>
                    <FormDialog
                      namevalue={values[profile + '_from']}
                      namelabel={profileParent[profile]?.title}
                      nametext="photo"
                      resource={resourceChildren[profile]}
                      onchangeData={(e) => handleOnchange(e, profile + '_from')}
                      text={resourceChildren[profile].find(e => e.value == values[profile + '_from'])?.label}
                    />
                  </div>
                  <div className="d-symbol-range">~</div>
                  <div className="d-range-right" style={(styleWrapInline, { width: '100%', position: 'relative' })}>
                    <FormDialog
                      namevalue={values[profile + '_to']}
                      namelabel={profileParent[profile]?.title}
                      nametext="photo"
                      resource={resourceChildren[profile]}
                      onchangeData={(e) => handleOnchange(e, profile + '_to')}
                      text={resourceChildren[profile].find(e => e.value == values[profile + '_to'])?.label}
                    />
                  </div>
                </div>
              </ListItem>
            </div>
          );
        }

        return true;
      });
  };

  const textFooter = () => {
    return textFooterEnv(envInfoList ?? []);
  };

  return (
    <div style={{ overflow: 'auto', height: '100vh' }}>
      <div className={styles.searchScreen}>
        <div className={styles.topNavContainer}>
          <TopNav name={'ユーザー検索（お試し）'} hasBackIcon={true} />
        </div>
        <div className={styles.listSelect}>
        {stickyContent && (
                    <div className="d-wrapper-header-section d-wrapper-header-padding box-sticky-content">
                      <div className={'d-info-text font-3'}
                           dangerouslySetInnerHTML={{ __html: stickyContent }}></div>
                    </div>
                  )}
          <List component="nav" className={["d-search-box d-search-box-custom"]}>
            {/*<div className={styles.infoRow} style={{ paddingTop: 20 }}>*/}
            {/*  <span className="font-2" style={{ paddingLeft: 15, paddingRight: 15 }}>*/}
            {/*    あなたの性別*/}
            {/*  </span>*/}
            {/*  <div className={styles.switch}>*/}
            {/*    男性*/}
            {/*    <FormControlLabel*/}
            {/*      control={*/}
            {/*        <Switch*/}
            {/*          color="primary"*/}
            {/*          checked={!gender}*/}
            {/*          onChange={() => setGender((prev) => !prev)}*/}
            {/*          classes={{*/}
            {/*            checked: styles.checked,*/}
            {/*            switchBase: styles.switchBase,*/}
            {/*            bar: styles.bar,*/}
            {/*          }}*/}
            {/*        />*/}
            {/*      }*/}
            {/*    />*/}
            {/*    女性*/}
            {/*  </div>*/}
            {/*</div>*/}
            <div>
              <ListItem className={`${styles.lableSelect} font-2`} style={{ ...styleItems }}>あなたの性別</ListItem>
              <ListItem style={{ ...styleListItem2 }}>
                <div className="d-flex justify-content-center d-item-box-search-text">
                  <div onClick={() => setGender(true)}
                       className={`${styles.btnItemSearch} w-100 mr-10 ${gender ? 'bg-main-search' : 'bg-main-search-none'}`}>
                    <div className="">男性</div>
                  </div>
                  <div onClick={() => setGender(false)}
                       className={`${styles.btnItemSearch} w-100 ${!gender ? 'bg-main-search' : 'bg-main-search-none'}`}>
                    <div className="">女性</div>
                  </div>
                </div>
              </ListItem>
            </div>

            <div>
              <ListItem className={`${styles.lableSelect} font-2`} style={{ ...styleItems }}>写真</ListItem>
              <ListItem style={{ ...styleListItem2 }}>
                <div className="d-flex justify-content-center d-item-box-search-text">
                  <div onClick={() => setPhotoStatus(null)}
                       className={`${styles.btnItemSearch} w-100 mr-10 ${!photoStatus ? 'bg-main-search' : 'bg-main-search-none'}`}>
                    <div className="">全て</div>
                  </div>
                  <div onClick={() => setPhotoStatus(1)}
                       className={`${styles.btnItemSearch} w-100 mr-10 ${photoStatus === 1 ? 'bg-main-search' : 'bg-main-search-none'}`}>
                    <div className="">写真なし</div>
                  </div>
                  <div onClick={() => setPhotoStatus(2)}
                       className={`${styles.btnItemSearch} w-100 ${photoStatus === 2 ? 'bg-main-search' : 'bg-main-search-none'}`}>
                    <div className="">写真あり</div>
                  </div>
                </div>
              </ListItem>
            </div>

            <div>
              <ListItem className={`${styles.lableSelect} font-2`} style={{ ...styleItems }}>年齢</ListItem>
              <ListItem style={{ ...styleListItem2 }}>
                <div className="d-item-box-search d-flex justify-content-center">
                  <div className="d-range-left" style={(styleWrapInline, { width: '100%', position: 'relative' })}>
                    <FormDialog
                      namevalue={ageFrom}
                      namelabel={'年齢'}
                      nametext="agefrom"
                      resource={displayAgeList()}
                      onchangeData={(e) => setAgeFrom(e)}
                      text={ageFrom}
                    />
                  </div>
                  <div className="d-symbol-range">~</div>
                  <div className="d-range-right" style={(styleWrapInline, { width: '100%', position: 'relative' })}>
                    <FormDialog
                      namevalue={ageTo}
                      namelabel={'年齢'}
                      nametext="ageto"
                      resource={displayAgeList()}
                      onchangeData={(e) => setAgeTo(e)}
                      text={ageTo}
                    />
                  </div>
                </div>
              </ListItem>
            </div>
            <div>
              <ListItem className={`${styles.lableSelect} font-2`} style={{ ...styleItems }}>都道府県</ListItem>
              <ListItem style={{ ...styleListItem2 }}>
                <div className="d-item-box-search">
                  <div style={(styleWrapInline, { width: '100%', position: 'relative' })}>
                    <FormDialog
                      namevalues={provinces}
                      nameValues={provinces}
                      namelabel={'地域'}
                      nametext="states"
                      resource={listState}
                      onchangeDatas={(e) => handleOnchange(e, 'states')}
                      text={showValueStates()}
                      type={'multiple'}
                    />
                  </div>
                </div>
              </ListItem>
            </div>
            {renderSearchBox()}
            <br />
          </List>

          <List className='d-search-box-list-custom'>
            <ListItem alignItems="flex-start" style={{ paddingLeft: 0, paddingRight: 0 }}>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-around',
                  position: 'fixed',
                  bottom: 52,
                  margin: 'auto',
                  width: '100%',
                  padding: '8px 0',
                  maxWidth: '560px',
                }}
              >
                <Button className="btn btn-main" variant="contained" onClick={handleSearch}>
                  <span>検索する</span>
                </Button>
                <Button className="btn btn-sub" variant="contained" onClick={handleClearSearch}>
                  <span>クリア</span>
                </Button>
              </div>
            </ListItem>
          </List>
        </div>
        <div style={{ marginTop: 'auto', display: 'flex', justifyContent: 'center', textAlign: 'center' }}>
          <p style={{ color: 'var(--text3)' }} className="font-3"
             dangerouslySetInnerHTML={{ __html: textFooter() }}></p>
        </div>
      </div>
    </div>
  );
}

SearchTrial.getInitialProps = async ({
                                       req, res, match, history, location, ...ctx
                                     }) => {
  let textWebPages = [];
  try {
    let result = await getTextWebPages();
    textWebPages = result?.data || [];
  } catch (e) {
    textWebPages = [];
  }

  const findBlogMyEdit = textWebPages?.find(ele => ele.link === DEFINED_TYPE_LINKS.SEARCH_USER_TRIAL && ACCESS_PAGE_LINK_STICKY_CONTENT_TYPE.includes(DEFINED_TYPE_LINKS.SEARCH_USER_TRIAL));

  return { textWebPage: findBlogMyEdit?.content || '' };
};

export default SearchTrial;
